import {queryHdl, mutationHdl} from "../graphqlHdr";
import OnlyParticipants from './onlyParticipants.gql'
import OnlyMeetingRooms from './onlyMeetingRooms.gql'
import OnlyExclusiveRooms from './onlyExclusiveRooms.gql'
import All from './all.gql'

export default {
  queryAll: (vueSelf, variables) => queryHdl.call(vueSelf, All, variables),

  participants: (vueSelf, variables) => queryHdl.call(vueSelf, OnlyParticipants, variables),

  meetingRooms: (vueSelf, variables) => queryHdl.call(vueSelf, OnlyMeetingRooms, variables),

  exclusiveRooms: (vueSelf, variables) => queryHdl.call(vueSelf, OnlyExclusiveRooms, variables),
}
